export const AUTHPROVIDERKEY = 'cw.ap';

export const AuthProviderType = {
    "Microsoft": 0,
    "MicrosoftGov": 1,
    "Google": 2
}

export const getAuthProvider = () => {
    return JSON.parse(localStorage.getItem(AUTHPROVIDERKEY));
}

export const setAuthProvider = (authProviderType) => {
    localStorage.setItem(AUTHPROVIDERKEY, JSON.stringify(authProviderType));
}
